import React from 'react';

import type { Placement } from '@atlaskit/dropdown-menu/types';

import { DropdownView } from './Dropdown.view';

export interface DropdownOption {
  label: string;
  value: string;
  icon?: React.ReactElement;
  isDisabled?: boolean;
  tooltip?: string;
}

export interface DropdownProps {
  isDisabled?: boolean;
  onChange: (option: DropdownOption) => void;
  options: DropdownOption[];
  currentValue: DropdownOption;
  position?: Placement;
}

export const Dropdown: React.FC<DropdownProps> = ({
  isDisabled,
  currentValue,
  options,
  position,
  onChange,
}: DropdownProps) => {
  const availableDropdownOptions = options.filter(
    (option) => option.value !== currentValue.value
  );

  return (
    <DropdownView
      position={position}
      isDisabled={isDisabled}
      currentValue={currentValue}
      options={availableDropdownOptions}
      onChange={onChange}
    />
  );
};
